import { TranslationType } from '../types';

export const ja: TranslationType = {
  common: {
    wallets: 'ウォレット',
    dashboard: 'ダッシュボード',
    settings: '設定',
    darkMode: 'ダークモード',
    lightMode: 'ライトモード',
    language: '言語',
    english: 'English',
    chinese: '中文',
    russian: 'Русский',
    german: 'Deutsch',
    indonesian: 'Bahasa Indonesia',
    korean: '한국어',
    japanese: '日本語',
    thai: 'ภาษาไทย',
    blog: 'ブログ'
  },
  footer: {
    quickLinks: 'クイックリンク',
    about: '私たちについて',
    terms: '利用規約',
    privacy: 'プライバシーポリシー',
    contact: 'お問い合わせ',
    copyright: '© 2025 XCH.live. All rights reserved.',
    description: 'Chiaブロックチェーンウォレット用の高度なモニタリングプラットフォーム。リアルタイムの取引通知を受け取り、即時通知で資産を保護し、コールドウォレットのアクティビティを監視します。',
    connectWithUs: 'お問い合わせ',
    builtBy: 'Spacescan.ioチームが❤️を込めて作りました'
  },
  home: {
    hero: {
      title: 'Chiaコールドウォレットのモニタリング',
      subtitle: 'XCH取引の即時メール通知を受け取る',
      input: {
        label: 'マスターキー（96文字）またはXCHアドレスを入力',
        placeholder: 'マスターキー（96文字）またはXCHアドレスを入力',
        helper: 'モニタリングを開始するにはマスターキーまたはXCHアドレスを入力してください'
      },
      buttons: {
        cardprefix: '$12',
        card: 'カードで支払う',
        strprefix: '50% OFF',
        str: 'STRで支払う'
      }
    },
    features: {
      title: '手遅れになる前にChiaを保護しましょう',
      subtitle: 'ハッカーを待たずに - 24/7モニタリングでコールドウォレットを積極的に保護',
      vault: {
        title: 'VaultとClawbackを有効化',
        description: '高度なボールトとクローバック機能で資産を保護'
      },
      monitoring: {
        title: '安全なモニタリング',
        description: '秘密鍵を公開せずにコールドウォレットのアクティビティを追跡'
      },
      alerts: {
        title: '即時通知',
        description: 'すべての取引について即時メール通知を受信'
      },
      recovery: {
        title: '資金の回収',
        description: 'クローバック期間中に未承認の取引から資金を回収'
      }
    },
    metrics: {
      title: '数字で見る私たちの影響',
      walletsMonitored: {
        label: 'モニタリング中のウォレット'
      },
      alertsSent: {
        label: '送信された通知'
      },
      transactionsAnalyzed: {
        label: '分析された取引'
      }
    },
    testimonials: {
      title: 'ユーザーの声',
      items: [
        {
          quote: 'XCH.liveのおかげで、私のコールドウォレットが24/7モニタリングされていることを知って安心できます。即時通知は本当に画期的です。',
          author: 'マイケル・チェン',
          role: 'Chiaファーマー'
        },
        {
          quote: 'セットアップが信じられないほど簡単で、モニタリングも信頼性があります。私のChia資産に必要なものがすべて揃っています。',
          author: 'サラ・ジョンソン',
          role: '暗号資産投資家'
        },
        {
          quote: 'Chiaウォレットのモニタリングに最適なソリューションです。メール通知が速く、ダッシュボードも非常に直感的です。',
          author: 'デイビッド・キム',
          role: 'ブロックチェーン開発者'
        }
      ]
    }
  },
  settings: {
    title: '設定',
    subtitle: 'ウォレット設定の管理',
    notifications: {
      title: '通知',
      emailNotifications: 'メール通知',
      emailDescription: '取引の更新をメールで受け取る',
      threshold: {
        title: '取引しきい値',
        description: '通知を送信する最小XCH金額（最小1 XCH）'
      }
    },
    walletInfo: {
      title: 'ウォレット情報',
      masterKey: 'マスターキー'
    },
    actions: {
      save: '変更を保存',
      delete: 'ウォレットを削除'
    },
    messages: {
      success: '設定が正常に保存されました！',
      error: {
        generic: '設定を更新できませんでした',
        threshold: 'しきい値は1 XCH以上である必要があります',
        delete: 'ウォレットを削除できませんでした'
      },
      deleteConfirm: 'このウォレットを削除してもよろしいですか？この操作は取り消せません。'
    }
  },
  wallets: {
    title: 'マイウォレット',
    subtitle: 'コールドウォレットの管理とモニタリング',
    status: {
      active: 'モニタリング中',
      pending: '支払い待ち',
      expired: 'モニタリング期限切れ',
      timeLeft: {
        days: '残り{{days}}日{{hours}}時間',
        hours: '残り{{hours}}時間{{minutes}}分',
        minutes: '残り{{minutes}}分',
        lessThanMinute: '残り1分未満'
      }
    },
    actions: {
      payWithCard: 'カードで支払う',
      completeCryptoPayment: '暗号資産での支払いを完了',
      renewMonitoring: 'モニタリングを更新',
      dashboard: 'ダッシュボード',
      settings: '設定',
      addFirstWallet: '最初のウォレットを追加',
      removeWallet: 'ウォレットを削除'
    },
    messages: {
      noWallets: 'ウォレットが見つかりません'
    }
  },
  dashboard: {
    title: 'ウォレットダッシュボード',
    tabs: {
      events: 'イベント',
      addresses: 'アドレス'
    },
    addresses: {
      totalAddresses: '合計アドレス数: {{count}}',
      index: 'インデックス',
      address: 'アドレス',
      actions: 'アクション'
    },
    events: {
      loadMore: 'さらに読み込む',
      noEvents: 'イベントが見つかりません',
      sent: '送信済み',
      received: '受信済み',
      spent: '使用済み',
      pending: '保留中',
      failed: '失敗',
      showDetails: '詳細を表示',
      hideDetails: '詳細を非表示',
      block: 'ブロック',
      viewOnSpacescan: 'Spacescanで表示',
      transactionHash: '取引ハッシュ',
      nftsReceived: 'NFT受信済み',
      nftsSent: 'NFT送信済み',
      nftTransaction: 'NFT取引',
      viewNFTDetails: 'NFT詳細を表示',
      receivedNFTs: '受信したNFT',
      sentNFTs: '送信したNFT'
    }
  },
  faq: {
    title: 'よくある質問',
    security: {
      question: 'モニタリングサービスはどのくらい安全ですか？',
      answer: '当社のサービスは、モニタリング目的で公開マスターキーのみを使用し、最高水準のセキュリティ基準で運営されています。秘密鍵や支出能力にアクセスすることはないため、お客様の資金は完全に安全です。BLS-12-381暗号化標準を使用しており、秘密鍵（32バイト）と公開鍵（48バイト）は分離され、安全に保管されています。',
      learnMore: 'ChiaのBLSキーについて詳しく学ぶ →'
    },
    monitoring: {
      question: '取引のモニタリング頻度はどのくらいですか？',
      answer: '当社のシステムは、Chiaブロックチェーンの各新規ブロックを確認し、リアルタイムで取引をモニタリングしています。モニタリング対象のすべてのアドレスのアクティビティを追跡し、ウォレットに影響を与えるすべての取引について即時通知を提供します。'
    },
    masterKey: {
      question: 'ウォレットの公開マスターキーはどのように見つけられますか？',
      answer: 'Chia GUIまたはCLIウォレットを通じて公開マスターキーにアクセスできます。このプロセスを案内する詳細なビデオチュートリアルを用意しています。重要：秘密鍵やシードフレーズは絶対に共有しないでください - 当社のモニタリングサービスには公開マスターキーのみが必要です。',
      videoTitle: '公開マスターキーの見つけ方',
      learnMore: 'キーの見つけ方について詳しく読む →'
    },
    addresses: {
      question: 'マスターキーで何個のアドレスがモニタリングされますか？',
      answer: '当社のサービスは、マスターキーに関連付けられた100個の派生アドレスをモニタリングし、ウォレットの取引アクティビティを完全にカバーします。'
    },
    singleAddress: {
      question: 'マスターキーの代わりに特定のアドレスだけをモニタリングできますか？',
      answer: 'はい、当社のサービスは個別のアドレスモニタリングに柔軟性を提供します。複数のアドレスをモニタリングするためのマスターキーの使用の代わりに、単一の特定のアドレスのモニタリングを選択できます。'
    },
    notifications: {
      question: '通知はどのように設定できますか？',
      answer: 'ウォレット設定を通じてメール通知を完全に制御できます。当社のダッシュボードは、モニタリングニーズに合わせて通知設定を調整するオプションを提供します。'
    },
    vault: {
      question: 'Chia vaultとは何で、どのように機能しますか？',
      answer: 'Chia vaultは、デジタル資産に強化された保護を提供する高度なセキュリティ機能です。マルチシグ要件や時間遅延取引などの追加のセキュリティ対策を実装します。ボールトは資産の保管をコインから分離し、取引承認に複数の署名（m-of-nマルチシグ）を要求できます。',
      learnMore: 'Chia Vaultsについて詳しく学ぶ →'
    },
    clawback: {
      question: 'ChiaのClawback機能とは何ですか？',
      answer: 'Clawbackは、特定の期間内に取引を取り消すことができるChiaのセキュリティ機能です。有効にすると、受信者は送金された資金にアクセスする前にクローバック期間が終了するまで待つ必要があり、これにより取引に追加のセキュリティレイヤーが提供されます。'
    },
    vaultSupport: {
      question: 'サービスはvaultとclawback機能をサポートしていますか？',
      answer: '当社はvaultとclawbackを使用する取引をモニタリングしていますが、これらの機能を直接管理することはありません。これらの機能はウォレット作成時に設定する必要があります。当社のサービスは、アドレスの取引モニタリングと通知の配信に焦点を当てています。'
    },
    tokens: {
      question: 'Chiaトークンのモニタリングを提供していますか？',
      answer: '現在、当社のモニタリングサービスはXCH取引のみに焦点を当てています。トークンモニタリング機能は現在のサービス提供に含まれていません。'
    },
    nft: {
      question: 'NFT取引のモニタリングは利用可能ですか？',
      answer: '現在、当社のサービスはXCH取引のモニタリングに特化しています。NFT取引のモニタリングは現在のサービス機能に含まれていません。'
    },
    subscription: {
      question: '購読および返金ポリシーはどのようになっていますか？',
      answer: '当社のサービスは購読ベースで提供されています。モニタリングサービスの即時性の性質上、サービスが有効化された後の返金は提供していません。購読する前に利用規約をご理解いただきますようお願いいたします。'
    }
  },
  notFound: {
    title: 'ページが見つかりません',
    lostMessage: 'あなたのChiaをこのページのように - 虚無に失わせないでください！',
    securityMessage: 'ホームに戻って、XCHを24時間体制で安全に監視する方法を見つけましょう。',
    protectButton: 'Chiaを保護する'
  }
}; 